import { call, put } from "redux-saga/effects";
import axios from "../../config/axiosConfig";
import {
	HOMEPAGE_DATA_SUCCESS,
	HOMEPAGE_DATA_ERROR,
	HOMEPAGE_DATA_UNCHANGED,
	GET_SECTION_GAMES_SUCCESS,
	GET_SECTION_GAMES_ERROR,
	GET_SECTION_GAMES_UNCHANGED,
} from "../actions/homeActions";
import { SILENT_LOGIN_REQUEST } from "../actions/authActions";
import { getUserMessages } from "../actions/messageActions";
import { TOAST_SHOW } from "../actions/toastActions";
import { ERROR_CODES } from '../../constants/errorCodes';
import { runCachedContentRequest } from "./contentCacheSaga";

const validateHomeResponse = (response) => {
	const hasAuthenticatedHome = Boolean(response?.data?.user?.id);
	const hasStoredToken = Boolean(localStorage.getItem("token"));
	if (!hasAuthenticatedHome && !hasStoredToken) {
		const error = new Error("Anonymous home response requires silent login recovery");
		error.code = "HOME_AUTH_RECOVERY";
		throw error;
	}
};

export function* loadHomepageDataSaga(action) {
	const result = yield* runCachedContentRequest({
		resource: "home",
		requestKey: action?.requestKey || "home",
		fetchRequest: () => axios.get("home"),
		cacheSuccessType: HOMEPAGE_DATA_SUCCESS,
		networkSuccessType: HOMEPAGE_DATA_SUCCESS,
		unchangedType: HOMEPAGE_DATA_UNCHANGED,
		errorType: HOMEPAGE_DATA_ERROR,
		validateResponse: validateHomeResponse,
	});

	if (result?.error?.code === "HOME_AUTH_RECOVERY") {
		console.warn("[Home] Anonymous /home payload received without a token — starting silent login recovery");
		yield put({ type: SILENT_LOGIN_REQUEST });
	}
	if (result?.error && !result.hasCachedData) {
		yield put({ type: TOAST_SHOW, payload: {message: `${ERROR_CODES.E5001}: Something went wrong please try again`,severity: "Danger",show: true}});
	}
	// For a signed-in visitor, /home is what creates today's daily reward on the
	// server, and it answers after the messages fetched when the page opened. Fetch
	// them again so the reward popup shows on the home page (AK-243).
	if (result?.response && localStorage.getItem("token") && !localStorage.getItem("isFromCustomCategory")) {
		yield put(getUserMessages({ force: true }));
	}
}

export function* fetchSectionGamesSaga(action) {
	const sectionId = action?.payload?.section_id;
	const result = yield* runCachedContentRequest({
		resource: "section",
		params: { sectionId: String(sectionId ?? "") },
		requestKey: action?.requestKey || `section:${String(sectionId ?? "")}`,
		fetchRequest: () => axios.post("/section", action.payload),
		cacheSuccessType: GET_SECTION_GAMES_SUCCESS,
		networkSuccessType: GET_SECTION_GAMES_SUCCESS,
		unchangedType: GET_SECTION_GAMES_UNCHANGED,
		errorType: GET_SECTION_GAMES_ERROR,
	});
	if (result?.error && !result.hasCachedData) {
		console.log("Error in fetchSectionGamesSaga", result.error);
		yield put({type: TOAST_SHOW,payload: {message: `${ERROR_CODES.E5002}: Something went wrong please try again`,severity: "Danger",show: true}});
	}
}

export function* fetchHomeDataSaga(action) {
	try {
		const response = yield call(axios.get, `api/home?t=${Date.now()}`);
		if (response?.status === 200) {
			yield put({type: GET_HOME_DATA_SUCCESS, payload: response?.data});
		}
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: {message: `${ERROR_CODES.E1001}: Something went wrong please try again`,severity: "Danger",show: true}});
		yield put({ type: GET_HOME_DATA_ERROR });
	}
}

export function* fetchHomeFeaturedSaga(action) {
	try {
		const response = yield call(axios.get, `api/featured?t=${Date.now()}`);
		if (response?.status === 200) {
			yield put({type: GET_HOME_FEATURED_SUCCESS, payload: response?.data});
		}
	} catch (e) {
		yield put({type: TOAST_SHOW,payload: {message: `${ERROR_CODES.E1001}: Something went wrong please try again`,severity: "Danger",show: true}});
		yield put({ type: GET_HOME_FEATURED_ERROR });
	}
}
